export default __webpack_public_path__ + "static/media/burger-menu.d8298b3e.svg";